
import { catchError } from "rxjs/operators";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { HandleError, HttpErrorHandler } from "../../../../../util/http-error-handler.service";
import { Observable } from "rxjs";
import MeioDeContato from "../../../../../models/perfil/meio-de-contato";


const API_URL = environment.apiUrl;

@Injectable({
  providedIn: "root"
})
export class MeioDeContatoService {
  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError("notificacaoService");
  }

  obterTodos(param: any, direcao: string, propriedade: string): Observable<any> {
    const params = new HttpParams()
      .set('Direcao', `${(direcao)}`)
      .set('Propriedade', `${(propriedade)}`)
      .set("pageNumber", `${param.offset}`)
      .set("pageSize", `${param.limit}`);
    return this.http
      .get<any>(`${API_URL}v1/meanscontact`, { params })
      .pipe(catchError(this.handleError("obter-todas", [])));
  }


  listarRedes(): Observable<any> {

    return this.http
      .get<any>(`${API_URL}v1/meanscontact/list`)
      .pipe(catchError(this.handleError("ListarUsuarios", [])));
  }

  cadastrar(record: MeioDeContato): Observable<any> {
    return this.http
      .post<any>(`${API_URL}v1/meanscontact`, record)
      .pipe(catchError(this.handleError("socialnetwork", record)));
  }

  atualizar(record: MeioDeContato): Observable<any> {
    return this.http
      .put<any>(`${API_URL}v1/meanscontact`, record)
      .pipe(catchError(this.handleError("socialnetwork", record)));
  }

  detalhar(id: number): Observable<any> {
    return this.http
      .get<any>(`${API_URL}v1/meanscontact/${id}`)
      .pipe(catchError(this.handleError("detalhar", [])));
  }

  remover(id: number): Observable<any> {
    return this.http
      .delete<any>(`${API_URL}v1/meanscontact/${id}`)
      .pipe(catchError(this.handleError("remover", [])));
  }

}
